/*********** Reduceres defined here *********/

import { persistCombineReducers } from "redux-persist";
import storage from "redux-persist/lib/storage"; 

// reducers
import user from "./modules/user";
import loader from "./modules/loader";
import logo from "./modules/logo";
import sidebar from "./modules/sidebar";
import search from "./modules/search";
import { createBrowserHistory } from "history";

/*********** History function **************/
export const history = createBrowserHistory();

const userPersistConfig = {
  key: "admin-app",
  storage: storage,
  blacklist: [
    "router",
    "loader",
    "vapi",
    "ElevenLab",
    "Subscription2",
    "Twilio",
  ],
};

export default persistCombineReducers(userPersistConfig, {
  router: history,
  loader,
  logo,
  user,
  search,
  sidebar,
});
